import { Post } from "@/types/post";
import { formatVehiclePlateToObj } from "./formatVehiclePlate";
import { FirebaseFirestoreTypes } from "@react-native-firebase/firestore";

const mapDocToPost = (doc: FirebaseFirestoreTypes.DocumentSnapshot): Post => {
  const data = doc.data()!;
  return {
    id: doc.id,
    eventDate: data.eventDate || "",
    eventType: data.eventType,
    author: {
      uid: data.author?.uid || "Unknown",
      displayName: data.author?.displayName || null,
      username: data.author?.username,
      country: data.author?.country || "Unknown",
      isVerified: data.author?.isVerified || false,
      photoURL: data.author?.photoURL,
    },
    image: data.images && data.images.length > 0 ? data.images[0] : undefined,
    images: data.images || [],
    description: data.description || "",
    location: data.location || {},
    vehiclePlates: data.vehiclePlates
      ? data.vehiclePlates.map(formatVehiclePlateToObj)
      : [],
    likes: data.likes || 0,
    commentCount: data.commentCount || 0,
    shares: data.shares || 0,
    date: data.createdAt?.toDate ? data.createdAt.toDate().toISOString() : "",
    plateFollowersOnly: data.plateFollowersOnly || false,
    createdAt: data.createdAt,
    groupId: data.groupId,
    sourceUrl: data.sourceUrl,
    anonymous: data.anonymous === true,
    editedAt: data.editedAt,
    lastEditedBy: data.lastEditedBy,
  };
};

export { mapDocToPost };